import api, { callRefresh } from "../common/apiClient";

const AuthApi = {
  login: async ({ email, password, rememberMe }) => {
    const payload = { email, password };
    if (typeof rememberMe === "boolean") payload.rememberMe = rememberMe;
    const { data } = await api.post(
      "/auth/login",
      payload,
      { skipAuth: true }
    );
    return data;
  },

  verifyTotp: async ({ mfaToken, code, rememberMe }) => {
    const payload = { mfaToken, code };
    if (typeof rememberMe === "boolean") payload.rememberMe = rememberMe;
    const { data } = await api.post(
      "/auth/mfa/totp/verify",
      payload,
      { skipAuth: true }
    );
    return data;
  },

  refresh: async () => {
    const data = await callRefresh();
    return data;
  },

  switchBusiness: async ({ businessId }) => {
    const { data } = await api.post("/auth/switch-business", { businessId });
    return data;
  },

  logout: async () => {
    await api.post("/auth/logout", {}, { skipAuth: true });
  },

  getSecurity: async () => {
    const { data } = await api.get("/auth/security");
    return data;
  },

  setTwoFactor: async ({ enabled }) => {
    const { data } = await api.post("/auth/security", { enabled });
    return data;
  },

  setupTotp: async ({ issuer = "Baknay", label = "Baknay" } = {}) => {
    const { data } = await api.post("/auth/mfa/totp/setup", { issuer, label });
    return data;
  },

  enableTotp: async ({ code }) => {
    const { data } = await api.post("/auth/mfa/totp/enable", { code });
    return data;
  },

  disableMfa: async () => {
    const { data } = await api.post("/auth/mfa/disable");
    return data;
  },

  changePassword: async ({ currentPassword, newPassword }) => {
    const { data } = await api.put("/auth/me/password", { currentPassword, newPassword });
    return data;
  },

  changeEmail: async ({ email }) => {
    const { data } = await api.put(
      "/auth/me/change-email",
      { email }
    );
    return data;
  },

  forgotPassword: async ({ email }) => {
    const { data } = await api.post(
      "/auth/forgot-password",
      { email }, { skipAuth: true }
    )
    return data;
  },

  resetPassword: async ({ token, newPassword }) => {
    const { data } = await api.post(
      "/auth/reset-password",
      { token, newPassword }, { skipAuth: true }
    )
    return data;
  },

  validateToken: async ({ token }) => {
    const { data } = await api.get(
      "/auth/validate-reset-token",
      { params: { token }, skipAuth: true }
    );
    return data;
  },

  validateEmailToken: async ({ token }) => {
    const { data } = await api.get(
      "/auth/validate-email-token",
      { params: { token }, skipAuth: true }
    );
    return data;
  },

  verifyEmail: async ({ token }) => {
    const { data } = await api.post(
      "/auth/verify-email", null,
      { params: { token }, skipAuth: true }
    );
    return data;
  },

  resendVerification: async ({ email }) => {
    const { data } = await api.post(
      "/auth/resend-email-verification",
      null,
      { params: { email }, skipAuth: true }
    );
    return data;
  },

  registerBusiness: async (payload) =>
    (await api.post("/auth/business/register", payload, { skipAuth: true })).data,

  checkBusinessNameAvailable: async (name) =>
    (await api.get("/auth/business/name-available", {
      params: { name },
      skipAuth: true,
    })).data,
};

export default AuthApi;
